import { Colors } from "assets/colors";

export const styles: any = {
  container: {
    padding: "2rem 1rem",
    backgroundColor: "white",
    borderRadius: "4px",
    border: `1px solid ${Colors.CardWhite}`,
    "& h1": {
      color: Colors.BlackText
    }
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: Colors.GrayText,
    fontSize: "1.1rem"
  }

} 
